import { render, staticRenderFns } from "./SampleProcessesGrid.vue?vue&type=template&id=283eaf7c&scoped=true&"
import script from "./SampleProcessesGrid.ts?vue&type=script&lang=ts&"
export * from "./SampleProcessesGrid.ts?vue&type=script&lang=ts&"
import style0 from "./SampleProcessesGrid.scss?vue&type=style&index=0&id=283eaf7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283eaf7c",
  null
  
)

export default component.exports